// cSpell:ignore flexbox, STYuanti, Hannotate

import styled from 'styled-components';


// 工具类
// 超出两行显示省略号
export const EllipsisTwoCell = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
`;

// 超出一行显示省略号
export const EllipsisOneCell = styled.div`
    overflow: hidden; 
    text-overflow: ellipsis; 
    -o-text-overflow: ellipsis;
    white-space:nowrap;
`;

// Flex 布局
export const Flex = styled.div`
    display: -moz-box; /* Firefox */
    display: -ms-flexbox; /* IE10 */
    display: -webkit-box; /* Safari */
    display: -webkit-flex; /* Chrome, WebKit */
    display: box;
    display: flexbox;
    display: flex;
    justify-content: normal;
`;

// 水平垂直居中（使用绝对定位方式）
export const AbsoluteCenterDiv = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
`;

// 垂直居中（使用绝对定位方式）
export const HorizontalCenterDiv = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
`;

// 水平居中（使用绝对定位方式）
export const VerticalCenterDiv = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
`;

// 样式类
export const BrownRow = styled.span`
    width: 0.38rem;
    height: 0.21rem;
    background: url(${require('./img/brown-row.png')}) no-repeat center;
    background-size: contain;
    transform: ${props => (props.active ? 'rotateZ(180deg)' : 'rotateZ(0)')};
    -webkit-transform: ${props => (props.active ? 'rotateZ(180deg)' : 'rotateZ(0)')};
    cursor: pointer;
`;

export const TwoTitle = styled.div`
    color: #fecc76;
    font-size: 0.32rem;
`;

export const LevelGuideBackground = styled(TwoTitle)`
    width: 1.92rem;
    height: 1.22rem;
    background: url(${require('./img/level-guide-bg.png')}) no-repeat top center;
    background-size: contain;
`;

export const UnitGuide = styled.div`
    width: 2.74rem;
    height: 3.01rem;
    background: url(${props => (props && props.direction === -1 ? require('./img/unit-guide-prev.png') : require('./img/unit-guide-next.png'))}) no-repeat
        center;
    background-size: contain;
    cursor: pointer;
`;

export const LessonNumber = styled.div`
    width: 1.33rem;
    height: 0.4rem;
    background: url(${props => (props.type && props.type === 'star' ? require('./img/lesson-number-star-active.png') : require('./img/lesson-number-bg.png'))})
        no-repeat center;
    background-size: contain;
    font-size: 0.29rem;
    color: #e39d76;
    line-height: 0.4rem;
    text-align: center;
    font-weight:normal;
`;

// 卡片标题
export const LessonTag = styled.div`
    position: absolute;
    top: -0.01rem;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    width: 100%;
    height: 0.48rem;
    background: url(${props => props.type ? require(`./img/lesson-${props.long ? 'long' : (typeof props.type === 'number' ? parseInt(props.type % 6, 10) : props.type)}.png`) : require(`./img/lesson-${props.long ? 'long' : '1'}.png`)})
        no-repeat center;
    background-size: contain;
    font-size: 0.22rem;
    text-align: center;
    line-height: 0.48rem;
    color: #fff;
    font-weight:400;
`;


export const Gift = styled.div`
    width: 1.02rem;
    height: 1.02rem;
    background: url(${require('./img/gift.png')}) no-repeat center;
    background-size: contain;
`;

// 蒙层
export const MaskBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: ${props => props.opacity ? `rgba(0, 0, 0, ${props.opacity})` : '#000'};
    z-index: 1000;
`;

// 返回按钮
export const IconBack = styled.div`
    position: fixed;
    top: 0.35rem;
    left: 0.64rem;
    height: 0.96rem;
    width: 0.96rem;
    background: url(${require('./img/icon-back.png')}) no-repeat center;
    background-size: contain;
    z-index: 1000;
    cursor: pointer;
`;

// 课程标题
export const LessonTitle = styled(Flex)`
    justify-content: center;
    align-items: center;
    font-weight: 400;
    height: 0.8rem;
    font-size: 0.26rem;
    text-align: center;
    margin: 0.1rem 0.24rem auto;
`;

export const Mask = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: ${props => props.opacity ? `rgba(0, 0, 0, ${props.opacity})` : `rgba(0, 0, 0, 0.8)`};
    z-index: ${props => props.zIndex ? props.zIndex : 100};
`;



// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/static/style.js